import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useAds } from "./useAds";

const POPUP_KEY = "dds_ads_popup_dismissed_v2";

export default function AdsPopup() {
  const { ads } = useAds("popup");
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (ads.length === 0) return;
    if (typeof window === "undefined") return;
    // Choose the most-recent ad not previously dismissed in this session
    const dismissed = JSON.parse(sessionStorage.getItem(POPUP_KEY) || "[]");
    const candidate = ads.find((a) => !dismissed.includes(a.id));
    if (!candidate) return;
    const t = setTimeout(() => {
      setActive(candidate);
      setOpen(true);
    }, 5000);
    return () => clearTimeout(t);
  }, [ads]);

  const close = () => {
    if (active) {
      const dismissed = JSON.parse(sessionStorage.getItem(POPUP_KEY) || "[]");
      sessionStorage.setItem(POPUP_KEY, JSON.stringify([...new Set([...dismissed, active.id])]));
    }
    setOpen(false);
  };

  if (!open || !active) return null;
  const a = active;

  return (
    <div
      className="fixed inset-0 z-[70] bg-black/60 backdrop-blur-sm grid place-items-center p-4 animate-in fade-in duration-200"
      onClick={close}
      data-testid="ads-popup-backdrop"
    >
      <div
        className="rounded-3xl shadow-2xl max-w-md w-full overflow-hidden relative animate-in zoom-in-95 duration-300"
        style={{
          backgroundColor: a.bg_color || "#FFFFFF",
          color: a.text_color || "#1a2332",
        }}
        onClick={(e) => e.stopPropagation()}
        data-testid={`ads-popup-${a.id}`}
      >
        <button
          onClick={close}
          aria-label="Fermer"
          data-testid="ads-popup-close"
          className="absolute right-3 top-3 w-8 h-8 rounded-full bg-black/15 hover:bg-black/25 flex items-center justify-center"
          style={{ color: a.text_color || "#1a2332" }}
        >
          <X className="w-4 h-4" />
        </button>
        {a.image_url && (
          <div className="aspect-video bg-black/5 overflow-hidden">
            <img src={a.image_url} alt={a.title || ""} className="w-full h-full object-cover" />
          </div>
        )}
        <div className="p-6 md:p-8">
          {a.title && <h3 className="font-headings font-black text-2xl md:text-3xl leading-tight">{a.title}</h3>}
          {a.subtitle && <p className="mt-2 text-base opacity-90">{a.subtitle}</p>}
          {a.body_text && <p className="mt-3 text-sm opacity-75 whitespace-pre-line">{a.body_text}</p>}
          {a.cta_label && a.cta_url && (
            <a
              href={a.cta_url}
              onClick={close}
              className="inline-flex items-center gap-2 mt-5 bg-[#FF8C42] hover:bg-[#e8763a] text-white font-headings font-bold rounded-xl px-5 py-3 text-sm shadow-md transition-all"
              data-testid={`ads-popup-cta-${a.id}`}
            >
              {a.cta_label} →
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
